module.exports = __webpack_public_path__ + "static/TangleTower3-2edabcdcde0985c3497ab874f1861230.png";